<div class="col-md-12">
  <div class="card">
    <div class="card-content">
      <div class="bootstrap-table">
        <div class="fixed-table-toolbar">
          <div class="pull-left search">
            <div class="icon-container" *ngIf="actionsConfig.showBackButton">
              <a (click)="back()" class="btn btn-default">
                <span class="ti-arrow-circle-left"></span><span class="icon-name"> Back</span>
              </a>
            </div>
            <ng-container *ngIf="actionsConfig.showSearch">
              <div class="input-group">
                <input
                  name="search"
                  class="form-control"
                  type="text"
                  placeholder="Search"
                  [(ngModel)]="searchTerm"
                  (keyup)="onSearch()"
                >
                <span class="input-group-addon" (click)="onSearch()">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </ng-container>
          </div>
          <div class="toolbar-middle" *ngIf="toolbarMiddleTemplate">
            <ng-container *ngTemplateOutlet="toolbarMiddleTemplate"></ng-container>
          </div>
          <div *ngIf="currentValidationErrors.length > 0" class="alert alert-danger">
            <div *ngFor="let error of currentValidationErrors">
              <strong>{{ error.columnLabel }}:</strong> {{ error.message }}
            </div>
          </div>
          <div class="columns columns-right">
            <button class="btn btn-default" title="Create" (click)="startCreate()" *ngIf="actionsConfig.showCreate">
              <i class="fa fa-plus-circle"></i>
            </button>
            <button class="btn btn-default" title="Download" (click)="downloadCSV()" *ngIf="actionsConfig.showDownload">
              <i class="fa fa-circle-down"></i>
            </button>
          </div>
        </div>
        <div class="fixed-table-container">
          <div class="fixed-table-body">
            <table class="table">
              <thead>
                <tr>
                  <th *ngFor="let column of columns" [innerHTML]="column.label"></th>
                  <th class="spacer-column">

                  </th>
                  <th *ngIf="actionsConfig.showEdit || actionsConfig.showDelete" class="td-actions text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let item of data" [formGroup]="editForms[item.id]">
                    <td *ngFor="let column of columns; let i = index">
                      <ng-container *ngIf="editItemID == item.id; else displayMode">
                        <app-form-field
                          [column]="column"
                          [controlName]="column.name"
                          [inputId]="'input-' + i"
                        ></app-form-field>
                      </ng-container>
                      <ng-template #displayMode>
                        <ng-container *ngIf="column.inputType === 'link' && column.linkRoute; else other">
                          <a [routerLink]="generateLink(column.linkRoute, item, column)">
                            <i class="fas fa-arrow-right"></i>
                          </a>
                        </ng-container>
                        <ng-template #other>
                          <app-display-field
                            [column]="column"
                            [value]="getDisplayValue(item, column)"
                          ></app-display-field>
                        </ng-template>
                      </ng-template>
                    </td>
                    <td class="spacer-column">
                    </td>
                    <td class="td-actions text-right">
                      <div class="table-icons">
                        <ng-container *ngIf="editItemID == item.id; else actionButtons">
                          <button [disabled]="editForms[item.id].invalid" class="btn btn-xs btn-success" (click)="saveEdit()">Save</button>
                          <button class="btn btn-xs" (click)="cancelEdit()">Cancel</button>
                        </ng-container>
                        <ng-template #actionButtons>
                          <a rel="tooltip" title="Edit" class="btn btn-simple btn-warning btn-icon table-action edit" (click)="startEdit(item.id)" *ngIf="actionsConfig.showEdit">
                            <i class="ti-pencil-alt"></i>
                          </a>
                          <a rel="tooltip" title="Remove" class="btn btn-simple btn-danger btn-icon table-action remove" (click)="startDelete(item.id)" *ngIf="actionsConfig.showDelete">
                            <i class="ti-close"></i>
                          </a>
                          <ng-container *ngIf="rowActionsTemplate">
                            <ng-container
                              *ngTemplateOutlet="rowActionsTemplate; context: { $implicit: item }">
                            </ng-container>
                          </ng-container>
                        </ng-template>
                      </div>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="fixed-table-pagination" >
          <div class="pull-left pagination">
          </div>
          <div class="pull-right pagination">
            <div class="pagination" *ngIf="totalPages > 1">
              <ul class="pagination">
                <li class="page-item" [class.disabled]="currentPage === 1">
                  <a class="page-first" href="javascript:void(0)" (click)="firstPage()">&lt;&lt;</a>
                </li>
                <li class="page-item" [class.disabled]="currentPage === 1">
                  <a class="page-pre" href="javascript:void(0)" (click)="prevPage()">&lt;</a>
                </li>
                <!-- <li class="page-item" *ngFor="let page of pageNumbers" [class.active]="currentPage === page">
                  <a class="page-number" href="javascript:void(0)" (click)="onCurrentPageChange(page)">{{ page }}</a>
                </li> -->
                <li class="page-item" *ngFor="let page of visiblePages" [class.active]="currentPage === page">
                  <ng-container *ngIf="page !== '...'; else ellipsis">
                    <a class="page-number" (click)="onCurrentPageChange(page)">
                      {{ page }}
                    </a>
                  </ng-container>
                  <ng-template #ellipsis>
                    <span class="page-number">…</span>
                  </ng-template>
                </li>
                <li class="page-item" [class.disabled]="currentPage === totalPages">
                  <a class="page-next" href="javascript:void(0)" (click)="nextPage()">&gt;</a>
                </li>
                <li class="page-item" [class.disabled]="currentPage === totalPages">
                  <a class="page-last" href="javascript:void(0)" (click)="lastPage()">&gt;&gt;</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>